import { Instagram, Facebook, MessageCircle, Phone, Mail, MapPin, ShieldCheck } from "lucide-react";
import {
  LOGO,
  INSTAGRAM,
  FACEBOOK,
  WHATSAPP_LINK,
  PHONE,
  PHONE_LINK,
  EMAIL,
  ADDRESS,
  NAV_LINKS,
} from "@/data/content";

export default function Footer({ scrollTo }) {
  return (
    <footer id="contact" data-testid="footer" className="bg-brand-ink text-white">
      <div className="mx-auto max-w-7xl px-6 py-20 md:py-24">
        <div className="flex flex-wrap items-end justify-between gap-8 border-b border-white/10 pb-12">
          <div>
            <img src={LOGO} alt="Abhi Institute of Hotel Management" className="h-12 w-auto rounded-sm bg-white p-1.5" />
            <p className="mt-6 font-serif text-4xl font-light leading-tight md:text-6xl">
              ABHI Institute
            </p>
            <p className="mt-2 font-serif text-lg italic text-white/60 md:text-xl">
              of Hotel Management, New Delhi
            </p>
          </div>
          <div className="flex gap-3">
            <a
              data-testid="footer-instagram-link"
              href={INSTAGRAM}
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="rounded-full border border-white/20 p-3.5 transition-colors duration-300 hover:border-white hover:bg-white hover:text-brand-ink"
            >
              <Instagram className="h-5 w-5" />
            </a>
            <a
              data-testid="footer-facebook-link"
              href={FACEBOOK}
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              className="rounded-full border border-white/20 p-3.5 transition-colors duration-300 hover:border-white hover:bg-white hover:text-brand-ink"
            >
              <Facebook className="h-5 w-5" />
            </a>
            <a
              data-testid="footer-whatsapp-link"
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp"
              className="rounded-full border border-white/20 p-3.5 transition-colors duration-300 hover:border-white hover:bg-white hover:text-brand-ink"
            >
              <MessageCircle className="h-5 w-5" />
            </a>
          </div>
        </div>

        <div className="grid gap-10 py-12 sm:grid-cols-2 lg:grid-cols-3">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50">Visit Us</p>
            <p className="mt-4 flex items-start gap-3 text-sm leading-relaxed text-white/80">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-white/50" />
              {ADDRESS}
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50">Talk to Us</p>
            <a href={PHONE_LINK} className="mt-4 flex items-center gap-3 text-sm text-white/80 transition-colors hover:text-white">
              <Phone className="h-4 w-4 shrink-0 text-white/50" />
              {PHONE}
            </a>
            <a href={`mailto:${EMAIL}`} className="mt-3 flex items-center gap-3 text-sm text-white/80 transition-colors hover:text-white">
              <Mail className="h-4 w-4 shrink-0 text-white/50" />
              {EMAIL}
            </a>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50">Explore</p>
            <div className="mt-4 flex flex-col gap-3">
              {NAV_LINKS.map((link) => (
                <button
                  key={link.id}
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                  onClick={() => scrollTo(link.id)}
                  className="text-left text-sm text-white/80 transition-colors hover:text-white"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-white/50">
          <p>© 2026 Abhi Institute of Hotel Management. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a
              data-testid="footer-admin-link"
              href="/admin/scholarships"
              className="inline-flex items-center gap-1.5 font-semibold text-white/60 transition-colors hover:text-white"
            >
              <ShieldCheck className="h-3.5 w-3.5" />
              Admin Login
            </a>
            <p className="font-mono uppercase tracking-[0.18em]">Dwarka · New Delhi · Est. 2008</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
